import Rest from '@/services/Rest';

export default class CourseService extends Rest {
    /**
     * @type {String}
     */
    static resource = 'course'
}